import React from "react";
import { Card } from "antd";
import In_situTreeIcon from "../../images/In_situTreeIcon.svg";
import TransplanTreeIcon from "../../images/TransplanTreeIcon.svg";
import CompensatoryTreeIcon from "../../images/CompensatoryTreeIcon.svg";
import LegendsIcon from "../../images/LegendsIcon.svg";
import MetrostationIcon from "../../images/MetrostationIcon.svg";
import "./Legend.css"; // Import the CSS file

const DottedLineIcon = () => (
  <svg width="30" height="10">
    <line
      x1="0"
      y1="5"
      x2="30"
      y2="5"
      stroke="#02b7bb"
      strokeWidth="3"
      strokeDasharray="5,5"
    />
  </svg>
);

const Legend = () => {
  return (
    <Card className="legend-card">
      <div className="legend-title">
        <img src={LegendsIcon} alt="Legend Icon" />
        LEGEND
      </div>
      <div className="legend-item">
        <DottedLineIcon />
        <span>Metro Line 3</span>
      </div>
      <div className="legend-item">
        <img src={MetrostationIcon} alt="MetrostationIcon" />
        <span>Metro Line 3 Station</span>
      </div>
      <div className="legend-item">
        <img src={In_situTreeIcon} alt="Insitu" />
        <span>Insitu</span>
      </div>
      <div className="legend-item">
        <img src={TransplanTreeIcon} alt="Transplant" />
        <span>Transplant</span>
      </div>
      <div className="legend-item">
        <img src={CompensatoryTreeIcon} alt="Compensatory" />
        <span>Compensatory</span>
      </div>
    </Card>
  );
};

export default Legend;